import React from "react";

const ToolbarSegment = props => (
    <div className="Toolbar_segment">{props.children}</div>
);

const Toolbar = ({
    color = "default", // default | primary | accent
    fullBleed = false,
    gutters = "sm",
    children
}) => {
    const padding = gutters ? `${gutters}-gutters` : "flush";
    return (
        <div className={`Toolbar Toolbar-${color} Toolbar-${padding}`}>
            {children}
        </div>
    );
};

export { ToolbarSegment };

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Toolbar.js